import produce from "immer";
import React from "react";
import { ITreeData, Tree } from "react-tech-tree";
import "react-tech-tree/dist/index.css";
import treeData from "../../data/tree.json";
import { IState } from "../../store/types.js";
import { styleName } from "../frameHelper";
import { ScreenProps } from "../types";
import BoardNode from "./BoardNode";
import "./index.css";

const { nodes: baseNodes, links: baseLinks }: ITreeData = treeData;

const SkipButton = ({ onClick }: { onClick: () => void }) => (
  <button type="button" className="nes-btn is-primary" onClick={onClick}>
    Finish
  </button>
);

const getNextActiveTiles = (activeTiles: IState["board"]["activeTiles"]) => {
  const availableTiles: Record<string, boolean> = {};
  baseLinks.forEach(link => {
    availableTiles[link.to] = !!activeTiles[link.from];
  });
  return availableTiles;
};

const getNodes = (activeTiles: IState["board"]["activeTiles"]) => {
  const nextActiveTiles = getNextActiveTiles(activeTiles);
  return produce(baseNodes, draft => {
    draft.forEach(row =>
      row.forEach(tile => {
        if (tile.id === undefined) return;
        if (nextActiveTiles[tile.id]) tile.className = "Node next-active";
        if (activeTiles[tile.id]) tile.className = "Node active";
      })
    );
  });
};

const generateClickHandler = (dispatch: ScreenProps["dispatch"]) => (
  e: React.MouseEvent<HTMLDivElement>
) => {
  const tile = e.target as HTMLDivElement;
  if (!tile.classList.contains("next-active")) return;
  dispatch({ type: "board/spendPoints", payload: { id: tile.id } });
};

function BoardScreen(props: ScreenProps) {
  const { state, dispatch } = props;
  const clickHandler = () =>
    dispatch({ type: "board/spendPoints", payload: undefined });
  const { activeTiles } = state.board;
  const nodes = getNodes(activeTiles);
  const nodeClickHandler = generateClickHandler(dispatch);
  return (
    <>
      <div id="tech-tree-actions">
        <span>{`${state.board.points} BP`}</span>
        <SkipButton onClick={clickHandler} />
      </div>
      <Tree
        id="tech-tree"
        nodes={nodes}
        links={baseLinks}
        nodeProps={{ styleName, onClick: nodeClickHandler }}
        NodeElement={BoardNode}
      />
    </>
  );
}

export default BoardScreen;
